import Main from '../views/main/main.vue'
import projectIndex from '@/views/jjgl/projectIndex'
import projectZjIndex from '@/views/jjgl/projectZjIndex'
import projectForm from '@/views/jjgl/projectForm'
import projectAdd from '@/views/jjgl/projectAdd'
import projectEdit from '@/views/jjgl/projectEdit'
import pmmxIndex from '@/views/jjgl/pmmxIndex'
import pmmxForm from '@/views/jjgl/pmmxForm'
import prsForm from '@/views/jjgl/prsForm'
import projectView from '@/views/jjgl/projectView'
import psuIndex from '@/views/jjgl/psuIndex'
import psuConfirmIndex from '@/views/jjgl/psuConfirmIndex'
import psuConfirmForm from '@/views/jjgl/psuConfirmForm'
import psuCheckIndex from '@/views/jjgl/psuCheckIndex'
import projectPsuIndex from '@/views/jjgl/projectPsuIndex'
import psuBmPayForm from '@/views/jjgl/psuBmPayForm'
import psuBzjPayForm from '@/views/jjgl/psuBzjPayForm'
import psuBmUploadFileForm from '@/views/jjgl/psuBmUploadFileForm'
import projectPbrIndex from '@/views/jjgl/projectPbrIndex'
import pbrCenterForm from '@/views/jjgl/pbrCenterForm'
import pbrListForm from '@/views/jjgl/pbrListForm'
import jjReportIndex from '@/views/jjgl/jjReportIndex'
import pbrConfirmIndex from '@/views/jjgl/pbrConfirmIndex'
import pbrConfirmForm from '@/views/jjgl/pbrConfirmForm'
import psuForm from '@/views/jjgl/psuForm'
import psuBmForm from '@/views/jjgl/psuBmForm'
import psuBatchForm from '@/views/jjgl/psuBatchForm'
import pInviteForm from '@/views/jjgl/pInviteForm'
import pInviteIndex from '@/views/jjgl/pInviteIndex'
import pInviteInfo from '@/views/jjgl/pInviteInfo'
import projectReviewRuleIndex from '@/views/jjgl/projectReviewRuleIndex'
import pgForm from '@/views/jjgl/pgForm'
import pexpertForm from '@/views/jjgl/pexpertForm'
import pgsuIndex from '@/views/jjgl/pgsuIndex'
import pgsuForm from '@/views/jjgl/pgsuForm'
import pgsIndex from '@/views/jjgl/pgsIndex'
import pgsForm from '@/views/jjgl/pgsForm'
import pgsignIndex from '@/views/jjgl/pgsignIndex'
import pgsignForm from '@/views/jjgl/pgsignForm'
import pbidConfirmIndex from '@/views/jjgl/pbidConfirmIndex'
import pbidConfirmForm from '@/views/jjgl/pbidConfirmForm'
import psuServicepayIndex from '@/views/jjgl/psuServicepayIndex'
import psuServicepayForm from '@/views/jjgl/psuServicepayForm'
import pjnoticeIndex from '@/views/jjgl/pjnoticeIndex'
import pjnoticeForm from '@/views/jjgl/pjnoticeForm'
import projectReviewGcTab from '@/views/jjgl/projectReviewGcTab'
import projectReviewIndex from '@/views/jjgl/projectReviewIndex'
import pqcIndex from '@/views/jjgl/pqcIndex'
import pqcForm from '@/views/jjgl/pqcForm'
import pjnoticeView from '@/views/jjgl/pjnoticeView'
import biddingHall from '@/views/jjgl/biddingHall'
import bidOpening from '@/views/jjgl/bidOpening'
import projectBidding from '@/views/bbgl/projectBidding'
import purchaseReport from '@/views/bbgl/purchaseReport'
import pbrTenderForm from '@/views/jjgl/pbrTenderForm'
import onlineBidding from '@/views/jjgl/onlineBidding'
import projectBiddingNotice from '@/views/bbgl/projectBiddingNotice'
import projectSetScoringFrom from '@/views/jjgl/projectSetScoringFrom'
import biddingView from '@/views/jjgl/biddingView'
import bidOpeningView from '@/views/jjgl/bidOpeningView'
import projectReviewScore from '@/views/jjgl/projectReviewScore'
import BMXXlist from '@/views/jjgl/BMXXlist'
import projectReportE from '@/views/bbgl/projectReportE'
import projectReportW from '@/views/bbgl/projectReportW'
import editWinningBid from '@/views/jjgl/editWinningBid'
import auctionHall from '@/views/jjgl/auctionHall'
import ptcIndex from '@/views/jjgl/ptcIndex'
import ptcform from '@/views/jjgl/ptcform'
import ptcEdit from '@/views/jjgl/ptcEdit'
import ptcview from '@/views/jjgl/ptcview'
import xmgd from '@/views/jjgl/xmgd'
import xmgdFrom from '@/views/jjgl/xmgdFrom'
import xmgdView from '@/views/jjgl/xmgdView'
import demandrecList from '@/views/demandrec/demandrecList'
import demandrecAddOrEdit from '@/views/demandrec/demandrecAddOrEdit'
import demandrecView from '@/views/demandrec/demandrecView'

export default [{
  path: '/jjgl',
  component: Main,
  redirect: '',
  meta: {
    title: '竞价管理',
    icon: 'guide'
  },
  children: [
    {
      path: 'projectIndex',
      component: projectIndex,
      name: 'projectIndex',
      meta: { title: '我的项目', keepAlive: true }
    },
    {
      path: 'projectZjIndex',
      component: projectZjIndex,
      name: 'projectZjIndex',
      meta: { title: '自采项目', keepAlive: true }
    },
    {
      path: 'projectForm',
      component: projectForm,
      name: 'projectForm',
      meta: { title: '新建项目', keepAlive: true }
    },
    {
      path: 'projectAdd',
      component: projectAdd,
      name: 'projectAdd',
      meta: { title: '新建项目', keepAlive: true }
    },
    {
      path: 'projectEdit',
      component: projectEdit,
      name: 'projectEdit',
      meta: { title: '编辑项目', keepAlive: true }
    },
    {
      path: 'pmmxIndex',
      component: pmmxIndex,
      name: 'pmmxIndex',
      meta: { title: '采购清单', keepAlive: true }
    },
    {
      path: 'pmmxForm',
      component: pmmxForm,
      name: 'pmmxForm',
      meta: { title: '采购清单', keepAlive: true }
    },
    {
      path: 'prsForm',
      component: prsForm,
      name: 'prsForm',
      meta: { title: '竞价规则', keepAlive: true }
    },
    {
      path: 'projectView',
      component: projectView,
      name: 'projectView',
      meta: { title: '查看项目', keepAlive: true }
    },
    {
      path: 'psuIndex',
      component: psuIndex,
      name: 'psuIndex',
      meta: { title: '报名信息', keepAlive: true }
    },
    {
      path: 'psuConfirmIndex',
      component: psuConfirmIndex,
      name: 'psuConfirmIndex',
      meta: { title: '报名审核', keepAlive: true }
    },
    {
      path: 'psuConfirmForm',
      component: psuConfirmForm,
      name: 'psuConfirmForm',
      meta: { title: '报名清单', keepAlive: true }
    },
    // {
    //   path: 'psuCheckIndex',
    //   component: psuCheckIndex,
    //   name: 'psuCheckIndex',
    //   meta: { title: '报名审核', keepAlive: true }
    // },
     {
      path: 'psuCheckIndex',
      component: projectPsuIndex,
      name: 'psuCheckIndex',
      meta: { title: '报名审核', keepAlive: true }
    },
    {
      path: 'psuBmPayForm',
      component: psuBmPayForm,
      name: 'psuBmPayForm',
      meta: { title: '报名费支付', keepAlive: true }
    },
    {
      path: 'psuBzjPayForm',
      component: psuBzjPayForm,
      name: 'psuBzjPayForm',
      meta: { title: '保证金支付', keepAlive: true }
    },
    {
      path: 'psuBmUploadFileForm',
      component: psuBmUploadFileForm,
      name: 'psuBmUploadFileForm',
      meta: { title: '上传附件', keepAlive: true }
    },
    {
      path: 'projectPbrIndex',
      component: projectPbrIndex,
      name: 'projectPbrIndex',
      meta: { title: '正在报价', keepAlive: true }
    },
    {
      path: 'pbrCenterForm',
      component: pbrCenterForm,
      name: 'pbrCenterForm',
      meta: { title: '报价大厅', keepAlive: true }
    },
    {
      path: 'pbrListForm',
      component: () =>pbrListForm,
      name: 'pbrListForm',
      meta: { title: '报价记录', keepAlive: true }
    },
    {
      path: 'pbrConfirmIndex',
      component: pbrConfirmIndex,
      name: 'pbrConfirmIndex',
      meta: { title: '报价确认', keepAlive: true }
    },
    {
      path: 'jjReportIndex',
      component: jjReportIndex,
      name: 'jjReportIndex',
      meta: { title: '采购报告', keepAlive: true }
    },
    {
      path: 'projectReportE',
      component: projectReportE,
      name: 'projectReportE',
      meta: { title: '采购报告', keepAlive: true }
    },
    {
      path: 'pbrConfirmForm',
      component: pbrConfirmForm,
      name: 'pbrConfirmForm',
      meta: { title: '报价确认', keepAlive: true }
    },
    {
      path: 'psuForm',
      component: psuForm,
      name: 'psuForm',
      meta: { title: '供应商报名', keepAlive: true }
    },
    {
      path: 'psuBmForm',
      component: psuBmForm,
      name: 'psuBmForm',
      meta: { title: '报名详情', keepAlive: true }
    },
    {
      path: 'psuBatchForm',
      component: psuBatchForm,
      name: 'psuBatchForm',
      meta: { title: '批量报名', keepAlive: true }
    },
    {
      path: 'pInviteForm',
      component: pInviteForm,
      name: 'pInviteForm',
      meta: { title: '邀请供应商', keepAlive: true }
    },
    {
      path: 'pInviteIndex',
      component: pInviteIndex,
      name: 'pInviteIndex',
      meta: { title: '受邀项目确认', keepAlive: true }
    },
    {
      path: 'pInviteInfo',
      component: pInviteInfo,
      name: 'pInviteInfo',
      meta: { title: '受邀项目确认详情', keepAlive: true }
    },
    {
      path: 'projectReviewRuleIndex',
      component: projectReviewRuleIndex,
      name: 'projectReviewRuleIndex',
      meta: { title: '评审规则', keepAlive: true }
    },
    {
      path: 'pgForm',
      component: pgForm,
      name: 'pgForm',
      meta: { title: '设置评分项目', keepAlive: true }
    },
    {
      path: 'pexpertForm',
      component: pexpertForm,
      name: 'pexpertForm',
      meta: { title: '评审人抽取', keepAlive: true }
    },
    {
      path: 'pgsuIndex',
      component: pgsuIndex,
      name: 'pgsuIndex',
      meta: { title: '评审人评分', keepAlive: true }
    },
    {
      path: 'pgsuForm',
      component: pgsuForm,
      name: 'pgsuForm',
      meta: { title: '评审人评分', keepAlive: true }
    },
    {
      path: 'pgsIndex',
      component: pgsIndex,
      name: 'pgsIndex',
      meta: { title: '确认评分', keepAlive: true }
    },
    {
      path: 'pgsForm',
      component: pgsForm,
      name: 'pgsForm',
      meta: { title: '确认评分', keepAlive: true }
    },
    {
      path: 'pgsignIndex',
      component: pgsignIndex,
      name: 'pgsignIndex',
      meta: { title: '项目会签', keepAlive: true }
    },
    {
      path: 'pgsignForm',
      component: pgsignForm,
      name: 'pgsignForm',
      meta: { title: '评审人会签', keepAlive: true }
    },
    {
      path: 'pbidConfirmIndex',
      component: pbidConfirmIndex,
      name: 'pbidConfirmIndex',
      meta: { title: '成交管理', keepAlive: true }
    },
    {
      path: 'pbidConfirmForm',
      component: pbidConfirmForm,
      name: 'pbidConfirmForm',
      meta: { title: '成交确认', keepAlive: true }
    },
    {
      path: 'psuServicepayIndex',
      component: psuServicepayIndex,
      name: 'psuServicepayIndex',
      meta: { title: '成交通知', keepAlive: true }
    },
    {
      path: 'psuServicepayForm',
      component: psuServicepayForm,
      name: 'psuServicepayForm',
      meta: { title: '服务费缴纳', keepAlive: true }
    },
    {
      path: 'pjnoticeIndex',
      component: pjnoticeIndex,
      name: 'pjnoticeIndex',
      meta: { title: '项目其他公告', keepAlive: true }
    },
    {
      path: 'pjnoticeForm',
      component: pjnoticeForm,
      name: 'pjnoticeForm',
      meta: { title: '编辑公告', keepAlive: true }
    },
    {
      path: 'projectReviewGcTab',
      component: projectReviewGcTab,
      name: 'projectReviewGcTab',
      meta: { title: '项目评审', keepAlive: true }
    },
    {
      path: 'projectReviewIndex',
      component: projectReviewIndex,
      name: 'projectReviewIndex',
      meta: { title: '项目评审', keepAlive: true }
    },
    {
      path: 'pqcIndex',
      component: pqcIndex,
      name: 'pqcIndex',
      meta: { title: '项目评审', keepAlive: true }
    },
    {
      path: 'pqcForm',
      component: pqcForm,
      name: 'pqcForm',
      meta: { title: '初审规则维护', keepAlive: true }
    },
    {
      path: 'pjnoticeView',
      component: pjnoticeView,
      name: 'pjnoticeView',
      meta: { title: '查看公告', keepAlive: true }
    },
    {
      path: 'biddingHall',
      component: biddingHall,
      name: 'biddingHall',
      meta: { title: '网上报价', keepAlive: true }
    },
    {
      path: 'biddingView',
      component: biddingView,
      name: 'biddingView',
      meta: { title: '报价详情', keepAlive: true }
    },
    {
      path: 'bidOpening',
      component: bidOpening,
      name: 'bidOpening',
      meta: { title: '投标开标', keepAlive: true }
    },
    {
      path: 'bidOpeningView',
      component: bidOpeningView,
      name: 'bidOpeningView',
      meta: { title: '开标详情', keepAlive: true }
    },
    {
      path: 'projectBidding',
      component: projectBidding,
      name: 'projectBidding',
      meta: { title: '采购报告', keepAlive: true }
    },
    {
      path: 'pbrTenderForm',
      component: pbrTenderForm,
      name: 'pbrTenderForm',
      meta: { title: '开标大厅', keepAlive: true }
    },
    {
      path: 'onlineBidding',
      component: onlineBidding,
      name: 'onlineBidding',
      meta: { title: '线上投标', keepAlive: true }
    },
    {
      path: 'projectBiddingNotice',
      component: projectBiddingNotice,
      name: 'projectBiddingNotice',
      meta: { title: '成交通知书', keepAlive: true }
    },
    {
      path: 'projectSetScoringFrom',
      component: projectSetScoringFrom,
      name: 'projectSetScoringFrom',
      meta: { title: '新增评分项', keepAlive: true }
    },
    {
      path: 'purchaseReport',
      component: purchaseReport,
      name: 'purchaseReport',
      meta: { title: '采购报告', keepAlive: true }
    },
    {
      path: 'projectReviewScore',
      component: projectReviewScore,
      name: 'projectReviewScore',
      meta: { title: '审核申请', keepAlive: true }
    },
    {
      path: 'BMXXlist',
      component: BMXXlist,
      name: 'BMXXlist',
      meta: { title: '报名信息', keepAlive: true }
    },
    {
      path: 'projectReportW',
      component: projectReportW,
      name: 'projectReportW',
      meta: { title: '查看采购报告', keepAlive: true }
    },
    {
      path: 'editWinningBid',
      component: editWinningBid,
      name: 'editWinningBid',
      meta: { title: '编写通知书', keepAlive: true }
    },
    {
      path: 'auctionHall',
      component: auctionHall,
      name: 'auctionHall',
      meta: { title: '报价大厅', keepAlive: true }
    },
    {
      path: 'ptcIndex',
      component: ptcIndex,
      name: 'ptcIndex',
      meta: { title: '协议管理', keepAlive: true }
    },
    {
      path: 'ptcform',
      component: ptcform,
      name: 'ptcform',
      meta: { title: '新建协议', keepAlive: true }
    },
    {
      path: 'ptcEdit',
      component: ptcEdit,
      name: 'ptcEdit',
      meta: { title: '协议编辑', keepAlive: true }
    },
    {
      path: 'ptcview',
      component: ptcview,
      name: 'ptcview',
      meta: { title: '查看协议', keepAlive: true }
    },
    {
      path: 'xmgd',
      component: xmgd,
      name: 'xmgd',
      meta: { title: '项目归档清单', keepAlive: true }
    },
    {
      path: 'xmgdFrom',
      component: xmgdFrom,
      name: 'xmgdFrom',
      meta: { title: '项目归档', keepAlive: true }
    },
    {
      path: 'xmgdView',
      component: xmgdView,
      name: 'xmgdView',
      meta: { title: '查看归档', keepAlive: true }
    },
    {
      path: 'demandrcList',
      component: demandrecList,
      name: 'demandrecList',
      meta: { title: '采购需求', keepAlive: true }
    },
    {
      path: 'demandrecView',
      component: demandrecView,
      name: 'demandrecView',
      meta: { title: '需求详情', keepAlive: true }
    },
    {
      path: 'demandrecAdd',
      component: demandrecAddOrEdit,
      name: 'demandrecAdd',
      meta: { title: '新增需求', keepAlive: true }
    },
    {
      path: 'demandrecEdit',
      component: demandrecAddOrEdit,
      name: 'demandrecEdit',
      meta: { title: '编辑需求', keepAlive: true }
    }
  ]
}]
